export function arrayFlat(input){
	return input.reduce(function(acc, val){
		return acc.concat(val);
	}, []);
}

export function arrayMatch(a1, a2){
	var len = a1.length;
	if (len !== a2.length) return false;
	for (var i=0; i<len; i++){
		if (a1[i] !== a2[i]) return false;
	}
	return true;
}

export function arrayClone(array){
	return array.slice();
}